import { Check } from "lucide-react";

export const Tile = ({ active, onClick, icon: Icon, label, testId, children }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    aria-pressed={active}
    className={`group relative flex min-h-[112px] flex-col items-center justify-center gap-3 border p-4 text-center transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 ${active ? "border-brand bg-brand text-cream" : "border-white/15 bg-ink text-bone hover:border-brand"}`}
  >
    {active && <Check className="absolute right-2 top-2 h-4 w-4" />}
    {Icon && <Icon className={`h-8 w-8 ${active ? "text-cream" : "text-brand"}`} />}
    {children}
    <span className="font-display text-[13px] font-bold uppercase leading-tight">{label}</span>
  </button>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">{label}</span>
    {children}
  </label>
);

export const inputCls = "mt-2 w-full border border-white/15 bg-ink px-4 py-3 text-base text-bone placeholder:text-zinc-500 focus:border-brand focus:outline-none";
